import get from "lodash/get";

export const getGapi = () => get(window, "gapi");

const SCOPE = "https://www.googleapis.com/auth/drive.readonly";
const DISCOVERY_DOCS = ["https://www.googleapis.com/discovery/v1/apis/drive/v3/rest"];

const initGoogleApi = () => {
  const gapi = getGapi();

  gapi.load("client:auth2", async () => {
    try {
      await gapi.client.init({
        apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
        clientId: process.env.REACT_APP_GOOGLE_API_CLIENT_ID,
        discoveryDocs: DISCOVERY_DOCS,
        scope: SCOPE,
      });
    } catch ({ message }) {
      console.error(message);
    }
  });
};

export default initGoogleApi;
